module.exports = __webpack_public_path__ + "static/media/Budget.70610db8.svg";